import { render, staticRenderFns } from "./TabbedNav.vue?vue&type=template&id=883f0110&"
import script from "./TabbedNav.vue?vue&type=script&lang=ts&"
export * from "./TabbedNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports